module.exports = __webpack_public_path__ + "static/img/download-sub-banner.bffac483.png";